import { render, staticRenderFns } from "./GenericNodeView.vue?vue&type=template&id=bda25b3c&scoped=true"
import script from "./GenericNodeView.vue?vue&type=script&lang=ts"
export * from "./GenericNodeView.vue?vue&type=script&lang=ts"
import style0 from "./GenericNodeView.vue?vue&type=style&index=0&id=bda25b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda25b3c",
  null
  
)

export default component.exports